import { emptyNextCorrection } from './did-you-mean-state.js';
export const setToNonEmptyQueryCorrection = (state, correction) => {
    const nonOptionalQueryCorrection = {
        ...emptyNextCorrection(),
        ...correction,
        correctedQuery: correction?.correctedQuery ||
            correction?.corrections[0]?.correctedQuery ||
            '',
    };
    state.queryCorrection = nonOptionalQueryCorrection;
    state.wasCorrectedTo = nonOptionalQueryCorrection.correctedQuery;
};
